// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"93":"list","180":"story"}[chunkId] || chunkId) + "-" + {"93":"108717157f86f023aa55","160":"6b74b67b8f700dbe3bbc","180":"7fbfd958844b14ee2983"}[chunkId] + ".css";
};